// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import VueI18n from 'vue-i18n';
import VModal from 'vue-js-modal';


import router from './router';

import App from './App';
import store from './store/store';

import {pl} from './lang/pl';
import {en} from './lang/en';
import 'whatwg-fetch';
import './css/main.css';

import VueTouch from 'vue-touch';
import Vuesax from 'vuesax';
import Lightbox from 'vue-pure-lightbox';

import 'vuesax/dist/vuesax.css'; //Vuesax styles
import VueGtag from "vue-gtag";
import axios from 'axios';

Vue.prototype.$http = axios;

Vue.use(VueGtag, {
  config: {id: "UA-159071720-1"}
}, router);

require('smoothscroll-polyfill').polyfill();


Vue.use(Lightbox);
Vue.use(Vuesax);
Vue.use(VModal, {
  dialog: true,
  dynamic: true,
});

Vue.use(VueTouch);
// Vue.use(VueScrollTo)
Vue.use(VueI18n);

Vue.config.lang = 'en';
Vue.locale('pl', pl);
Vue.locale('en', en);
// Vue.locale('de', en);

Vue.config.productionTip = false;


let v = new Vue({
  store,
  el: '#app',
  router,
  template: '<App/>',
  components: {App}
});



// WEBPACK FOOTER //
// ./src/main.js